class NewsfeedReactBridge {
  constructor(NewsfeedCollection) {
    'ngInject';

    Object.assign(this, { NewsfeedCollection });
  }

  onAddComment = (comment) => {
    this.NewsfeedCollection.addComment({
      ...comment,
      channelId: comment.pageId,
      posted: comment.posted.toISOString(),
    });
  };

  onAddArticleLike = (data) => {
    this.NewsfeedCollection.addArticleLike(data);
  };

  onRemoveArticleLike = (data) => {
    this.NewsfeedCollection.deleteArticleLike(data);
  };

  onDeleteComment = ({ pageId, articleId, commentId }) => {
    this.NewsfeedCollection.deleteComment({ id: commentId, articleId, channelId: pageId });
  };

  getPageMemberIds = (pageId) => {
    const page = this.NewsfeedCollection.allChannels.find((c) => String(c.id) === String(pageId));
    return page?.members.map((m) => m.id) || [];
  };

  getPageMembersCount = (pageId) => {
    const page = this.NewsfeedCollection.allChannels.find((c) => String(c.id) === String(pageId));
    return page?.members.length || 0;
  };
}

export default NewsfeedReactBridge;
